import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const BeveragesMain = lazyWithChunkReload(() =>
  import("./beverages/beverages.main").then((m) => ({ default: m.BeveragesMain }))
);
export const ContinentEmployeeCommutingMain = lazyWithChunkReload(() =>
  import("./continent-employee-commuting/continent-employee-commuting.main").then((m) => ({
    default: m.ContinentEmployeeCommutingMain,
  }))
);
export const CoolingMain = lazyWithChunkReload(() =>
  import("./cooling/cooling.main").then((m) => ({ default: m.CoolingMain }))
);
export const ElectricityMain = lazyWithChunkReload(() =>
  import("./electricity/electricity.main").then((m) => ({ default: m.ElectricityMain }))
);
export const FlightClassMain = lazyWithChunkReload(() =>
  import("./flight-class/flight-class.main").then((m) => ({ default: m.FlightClassMain }))
);
export const FoodMain = lazyWithChunkReload(() => import("./food/food.main").then((m) => ({ default: m.FoodMain })));
export const FugitivesMain = lazyWithChunkReload(() =>
  import("./fugitives/fugitives.main").then((m) => ({ default: m.FugitivesMain }))
);
export const HeatingAndFuelMain = lazyWithChunkReload(() =>
  import("./heating-and-fuel/heating-and-fuel.main").then((m) => ({ default: m.HeatingAndFuelMain }))
);
export const HomeOfficeMain = lazyWithChunkReload(() =>
  import("./home-office/home-office.main").then((m) => ({ default: m.HomeOfficeMain }))
);
export const HotelStaysMain = lazyWithChunkReload(() =>
  import("./hotel-stays/hotel-stays.main").then((m) => ({ default: m.HotelStaysMain }))
);
export const MeansOfTransportMain = lazyWithChunkReload(() =>
  import("./means-of-transport/means-of-transport.main").then((m) => ({ default: m.MeansOfTransportMain }))
);
export const PrivateAndRentalVehicleMain = lazyWithChunkReload(() =>
  import("./private-and-rental-vehicle/private-and-rental-vehicle.main").then((m) => ({
    default: m.PrivateAndRentalVehicleMain,
  }))
);
export const RailTravelMain = lazyWithChunkReload(() =>
  import("./rail-travel/rail-travel.main").then((m) => ({ default: m.RailTravelMain }))
);
export const RefrigerantMain = lazyWithChunkReload(() =>
  import("./refrigerant/refrigerant.main").then((m) => ({ default: m.RefrigerantMain }))
);
export const TransportMain = lazyWithChunkReload(() =>
  import("./transport/transport.main").then((m) => ({ default: m.TransportMain }))
);
export const VehicleFuelTypeMain = lazyWithChunkReload(() =>
  import("./vehicle-fuel-type/vehicle-fuel-type.main").then((m) => ({ default: m.VehicleFuelTypeMain }))
);
export const WasteCategoryMain = lazyWithChunkReload(() =>
  import("./waste-category/waste-category.main").then((m) => ({ default: m.WasteCategoryMain }))
);
export const WaterMain = lazyWithChunkReload(() =>
  import("./water/water.main").then((m) => ({ default: m.WaterMain }))
);
